import { onyxBreakpoints } from '@onyx/ui/themes';

export const getClientDevice = () => {
  const width = window.innerWidth;
  if (width >= onyxBreakpoints.lg) {
    return 'desktop';
  }
  if (width >= onyxBreakpoints.md) {
    return 'tablet';
  }
  return 'mobile';
};
